import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './common/Layout/Layout';
import { HomePage } from './pages/HomePage/HomePage';
import { SectionPage } from './pages/SectionPage/SectionPage';
import { ContentPage } from './pages/ContentPage/ContentPage';
import { useApi } from '../hooks/useApi';
import { useBackgroundImage } from '../hooks/useBackgroundImage';
import { SiteConfig } from '../types/api';

export const AppContent: React.FC = () => {
  // Get site configuration for hero props
  const { data: siteConfig } = useApi<SiteConfig>('/config/site.json');
  
  // Get dynamic background image (now inside Router context)
  const { backgroundImage } = useBackgroundImage();

  const heroProps = siteConfig ? {
    backgroundImage,
    logo: siteConfig.site.logo,
    title: siteConfig.site.title,
    description: siteConfig.site.description,
  } : undefined;

  return (
    <Layout heroProps={heroProps}>
      <Routes>
        {/* Home page */}
        <Route path="/" element={<HomePage />} />
        
        {/* Redirect old about URL to new my-diabetes URL */}
        <Route path="/about" element={<Navigate to="/my-diabetes" replace />} />
        
        {/* Redirect what-is-diabetes to the actual content page */}
        <Route path="/what-is-diabetes" element={<Navigate to="/what-is-type1-diabetes" replace />} />
        
        {/* Section pages */}
        <Route path="/my-diabetes" element={<SectionPage />} />
        <Route path="/medical" element={<SectionPage />} />
        <Route path="/info-for-whanau" element={<SectionPage />} />
        <Route path="/links" element={<SectionPage />} />
        <Route path="/regions" element={<SectionPage />} />
        
        {/* Content pages */}
        <Route path="/uni" element={<ContentPage />} />
        <Route path="/food" element={<ContentPage />} />
        <Route path="/relationships" element={<ContentPage />} />
        <Route path="/living-with-diabetes" element={<ContentPage />} />
        <Route path="/sick-days" element={<ContentPage />} />
        <Route path="/tips-and-tricks" element={<ContentPage />} />
        <Route path="/exercise" element={<ContentPage />} />
        <Route path="/alcohol" element={<ContentPage />} />
        <Route path="/apps" element={<ContentPage />} />
        <Route path="/insulin" element={<ContentPage />} />
        <Route path="/understanding-insulin" element={<ContentPage />} />
        <Route path="/testing" element={<ContentPage />} />
        <Route path="/correction" element={<ContentPage />} />
        <Route path="/clinics" element={<ContentPage />} />
        <Route path="/health-care" element={<ContentPage />} />
        <Route path="/issues-with-type1" element={<ContentPage />} />
        <Route path="/what-is-type1-diabetes" element={<ContentPage />} />
        <Route path="/supporting-someone" element={<ContentPage />} />
        <Route path="/diabetes-food-police" element={<ContentPage />} />
        <Route path="/diabetes-waitemata" element={<ContentPage />} />
        <Route path="/help-and-support" element={<ContentPage />} />
        <Route path="/acute-complications" element={<ContentPage />} />
      </Routes>
    </Layout>
  );
};

export default AppContent;
